module.exports = __webpack_public_path__ + "img/安庆帝伯格茨.png";